module.exports = __webpack_public_path__ + "1183c496c603d28f8a4e76927e8ceaf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/alipay_inactive.png
// module id = 582
// module chunks = 0